/** Human-readable listing publication timestamp for cards and detail views. */
export function formatListingPublishedAt(iso: string, locale?: string): string {
  try {
    const d = new Date(iso)
    if (Number.isNaN(d.getTime())) return iso
    return d.toLocaleString(locale, { dateStyle: 'medium', timeStyle: 'short' })
  } catch {
    return iso
  }
}
